export default __webpack_public_path__ + "static/media/9.fd88f360.webp";